import { Link } from 'react-router-dom';
import { Phone, Zap } from 'lucide-react';
import { CLINIC } from '../data/clinic';
import { useLang } from '../i18n';

// Always-visible bottom bar on mobile so patients can call or walk in from any page.
const MobileCallBar = () => {
  const { t } = useLang();
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 grid grid-cols-2 xl:hidden"
      data-testid="mobile-call-bar"
      style={{ boxShadow: '0 -6px 20px rgba(26,23,20,0.12)' }}
    >
      <a
        href={CLINIC.phoneHref}
        data-testid="mobile-bar-call"
        className="flex items-center justify-center gap-2 bg-[#1B1815] text-white py-4 text-[15px] font-semibold uppercase tracking-[0.12em]"
      >
        <Phone className="w-5 h-5" /> {t.urgent.callNow}
      </a>
      <Link
        to="/walk-in"
        data-testid="mobile-bar-walkin"
        className="flex items-center justify-center gap-2 bg-[#1E4E8C] text-white py-4 text-[15px] font-semibold uppercase tracking-[0.12em]"
      >
        <Zap className="w-5 h-5" /> {t.mobile.walkin}
      </Link>
    </div>
  );
};

export default MobileCallBar;
